export const dexTradesHints = {
  dexTrades: 'List of trade transactions made through dex.superhero.com',
  hash: 'Unique identifier of the transaction.',
  executed: 'Exact date and time when the trade was executed.',
  action: 'Uses Wrapped AE as base currency if they are part of the trading pair and Wrapped AE otherwise.',
  tokenAmountIn: 'Amount of tokens put at DEX.',
  tokenAmountOut: 'Amount of tokens received at DEX.',
  swappedRate: 'The exchange rate at which the transaction was made.',
  value: 'Total transaction value in USD.',
}
